<template>
    <div ref="container">
        <v-row v-if="(item.timetrackings && item.timetrackings.length > 0) || item.comments && item.comments.length > 0"
            class="mb-4">
            <v-col v-if="item.timetrackings && item.timetrackings.length > 0" cols="12"
                :lg="item.comments && item.comments.length > 0 ? 6 : 12">
                <eod-timetrackings :value="item.timetrackings" readonly collapsable></eod-timetrackings>
            </v-col>
            <v-col v-if="item.comments && item.comments.length > 0" cols="12"
                :lg="item.timetrackings && item.timetrackings.length > 0 ? 6 : 12">
                <eod-comments :value="item.comments" readonly collapsable show-start-workflow
                    @createWorkflow="showCreateWorkflow"></eod-comments>
            </v-col>
        </v-row>
        <v-row v-if="(item.products && item.products.length > 0) || item.productTypes && item.productTypes.length > 0">
            <v-col v-if="item.products && item.products.length > 0" cols="12"
                :lg="item.productTypes && item.productTypes.length > 0 ? 6 : 12">
                <v-card outlined>
                    <v-card-title>Material</v-card-title>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">Naam</th>
                                    <th class="text-left">Aantal</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(product, index) in item.products" :key="index">
                                    <td>{{ product.name }}</td>
                                    <td>{{ product.quantity }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>
        <div v-if="template">
            <v-tabs v-model="activeTab" @change="val => $refs.form.setStepIndex(val)">
                <v-tab v-for="(page, index) in template.content.pages" :key="index">
                    {{ page.name }}
                </v-tab>
            </v-tabs>

            <eod-task-form hide-page ref="form" v-if="item && template" :value="item" :template="template" readonly
          @onCreateTask="showCreateWorkflow"></eod-task-form>

            <eod-workflow-dialog v-if="startWorkflowDialog" v-model="startWorkflowDialog" :workflow="createWorkflowData"
                @saved="workflowSaved"></eod-workflow-dialog>
            <v-snackbar v-model="createWorkflowSuccess" color="success" :right="true" :top="true" timeout="3000" @click.native="createWorkflowSuccess = false">
                Workflow succesvol aangemaakt!
            </v-snackbar>
        </div>
    </div>
</template>
<script>
import eodCell from './eod-cell.vue';
import eodTimetrackings from './eod-timetrackings.vue';
import eodComments from './eod-comments.vue';
import eodObjectAutocomplete from './eod-object-autocomplete.vue';
import eodWorkflowDialog from './eod-workflow-dialog.vue';

export default {
    name: 'ResponseDetail',
    components: {
        eodCell,
        eodTimetrackings,
        eodComments,
        eodObjectAutocomplete,
        eodWorkflowDialog,
    },
    props: {
        itemid: String
    },
    data() {
        return {
            activeTab: 0,
            item: {
                timetrackings: [],
                comments: [],
                products: [],
                productTypes: [],
                metrics: []
            },
            measurementTypes: [],
            template: null,
            showimages: [],
            showcomments: [],
            createWorkflowSuccess: false,
            startWorkflowDialog: false,
            createWorkflowData: null,
            tempWorkflowData: null,
        }
    },
    created() {
        this.$eod.getById('response', this.itemid, ['id', 'createdAt', 'updatedAt', 'job{id}', 'timetrackings{userId workTypeId startedAt duration comment}', 'comments{userId content images createdAt}', 'measurements{time value cellId measurementType{id} product{id} comments{createdAt userId content} storageObjects{id key name}}']).then(result => {
            return result.data.data.response;
        }).then((response) => {
            return this.$eod.getById('task', response.job.id, ['id','category','stepType','parent{id taskType{id}} project{id name} company{id name} service{id name} jobType{id} templates{id name type object content} articles{id name quantity}'])
                .then(result => {
                    response.job = result.data.data.task;

                    const templates = response.job.templates;
                    if (templates) {
                        for (let i = 0; i < templates.length; i++) {
                            if (['TASK', 'JOB_TYPE'].includes(templates[i].object) && ['FORM', 'WORKFLOW'].includes(templates[i].type)) {
                                this.template = templates[i];
                                this.loadMeasurementTypes();
                                break;
                            }
                        }
                    }
                    
                    return response;
                });
        }).then(response => {
            this.item = response;
        });
    },
    methods: {
        async workflowSaved(task) {
            this.createWorkflowData = null;
            this.startWorkflowDialog = false;
            this.createWorkflowSuccess = true;

            this.$emit('workflowCreated', task);
        },
        async showCreateWorkflow(data) {

            let workflowData = {
                project: this.item.job.project,
                company: this.item.job.company,
                service: this.item.job.service,
            };

            const preparedData = await this.$eod.prepareCreateWorkflowData(data);

            this.createWorkflowData = {
                ...workflowData,
                ...preparedData
            }

            this.$nextTick(() => {
                this.startWorkflowDialog = true;
            });

        },
        loadMeasurementTypes() {
            let ids = [];
            for (let i = 0; i < this.template.content.pages.length; i++) {
                const page = this.template.content.pages[i];
                for (let j = 0; j < page.cells.length; j++) {
                    const cell = page.cells[j];
                    if (cell.typeId == 'measurementType') {
                        ids.push(cell.settings.measurementTypeId);
                    }
                }
            }

            this.$eod.get('measurementTypes', ['id unit{id name} name description formConfig{category type subCategory enabled values} valueConfigList{id itemType listItems{id name threshold}} valueConfigListItems{id name threshold}'], {
                whereIn: {
                    column: 'id',
                    array: ids
                }
            }).then(response => {
                this.measurementTypes = response.data.data.measurementTypes.edges;
            });
        },
    }
}
</script>